import { render, staticRenderFns } from "./BUTTON_ITEM.vue?vue&type=template&id=1576ad5a&scoped=true&"
import script from "./BUTTON_ITEM.vue?vue&type=script&lang=js&"
export * from "./BUTTON_ITEM.vue?vue&type=script&lang=js&"
import style0 from "./BUTTON_ITEM.vue?vue&type=style&index=0&id=1576ad5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1576ad5a",
  null
  
)

export default component.exports